import { lookupGetStateOld } from 'legacy/lut/store'

export const getAllCountriesCode = () => {
  const resultCodes: any = {}
  lookupGetStateOld().references.countries.forEach((element: any) => {
    if (!resultCodes[element.phoneCode]) {
      resultCodes[element.phoneCode] = [element.value]
    } else {
      resultCodes[element.phoneCode].push(element.value)
    }
  })
  return resultCodes
}
